import { render, staticRenderFns } from "./FamCode.vue?vue&type=template&id=587adf9f&scoped=true&"
import script from "./FamCode.vue?vue&type=script&lang=js&"
export * from "./FamCode.vue?vue&type=script&lang=js&"
import style0 from "./FamCode.vue?vue&type=style&index=0&id=587adf9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587adf9f",
  null
  
)

component.options.__file = "FamCode.vue"
export default component.exports